import { Chip } from "@mui/material";

export const STATUS_STYLES: Record<string, { label: string; bgcolor: string; color: string }> = {
  TO_BE_SCHEDULED: { label: "TBS", bgcolor: "#ffebee", color: "#c62828" },
  SCHEDULED: { label: "S", bgcolor: "#e3f2fd", color: "#1565c0" },
  IN_PROGRESS: { label: "IP", bgcolor: "#fff3e0", color: "#ef6c00" },
  WORK_COMPLETE: { label: "WC", bgcolor: "#e8eaf6", color: "#3949ab" },
  JOB_COSTING: { label: "JC", bgcolor: "#fffde7", color: "#f9a825" },
  READY_TO_BILL: { label: "RB", bgcolor: "#f3e5f5", color: "#6a1b9a" },
  COMPLETE: { label: "C", bgcolor: "#e8f5e9", color: "#2e7d32" },
};

const StatusChip = ({ status }: { status: string }) => {
  const config = STATUS_STYLES[status];
  if (!config) return null;

  return (
    <Chip
      label={config.label}
      size="small"
      sx={{
        height: 16,
        fontSize: "0.6rem",
        bgcolor: config.bgcolor,
        color: config.color,
      }}
    />
  );
};

export default StatusChip;
